import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S8};
  width: 100%;
`;

const RatingNumberContainer = styled.div`
  ${({ theme }) => theme.fontSize.M14};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S2};
  min-width: 40px;
`;

const RatingNumber = styled.div`
  ${({ theme }) => theme.fontSize.M14};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
`;

const ProgressBarContainer = styled.div`
  flex: 1;
  height: 4px;
  background-color: ${({ theme }) => theme.colors.GREY_LIGHT};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  overflow: hidden;
`;

const ProgressBarFill = styled.div<{ percentage: number }>`
  height: 100%;
  background-color: ${({ theme }) => theme.colors.GREY_DARKER};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  width: ${(props) => props.percentage}%;
`;

const RatingCount = styled.div`
  ${({ theme }) => theme.fontSize.M14};
  display: flex;
  justify-content: center;
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  min-width: 40px;
`;

export {
  Container,
  RatingNumberContainer,
  RatingNumber,
  ProgressBarContainer,
  ProgressBarFill,
  RatingCount,
};
